var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEyeOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.707 3.293a1 1 0 0 1 0 1.414l-16 16a1 1 0 0 1-1.414-1.414l16-16a1 1 0 0 1 1.414 0Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.03 5.556C14.067 5.209 13.05 5 12 5 6.976 5 2.74 9.787 1.423 11.444a.885.885 0 0 0 0 1.112 23.16 23.16 0 0 0 3.265 3.342l1.421-1.421A20.73 20.73 0 0 1 3.561 12c.69-.793 1.718-1.858 2.968-2.806C8.221 7.912 10.112 7 12 7c.475 0 .95.058 1.421.164l1.609-1.608Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.549 8.037a4 4 0 0 0-4.511 4.511l4.51-4.51ZM8.894 14.52a4 4 0 1 0 5.627-5.627l-1.43 1.43a2 2 0 1 1-2.767 2.767l-1.43 1.43Z",
  fill: "currentColor"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.765 15.65C9.12 16.47 10.56 17 12 17c1.888 0 3.78-.912 5.47-2.194 1.251-.948 2.279-2.013 2.969-2.806-.69-.793-1.718-1.858-2.968-2.806a13.423 13.423 0 0 0-1.988-1.263l1.475-1.475c2.706 1.549 4.77 3.919 5.619 4.988a.885.885 0 0 1 0 1.112C21.261 14.213 17.024 19 12 19c-2.08 0-4.026-.821-5.685-1.9l1.45-1.45Z",
  fill: "currentColor"
})));
export default SvgEyeOff;